import axios from "axios";
import getCsrfToken from "common/utils/getCsrfToken";

export default axios.create({
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "X-CSRF-Token": getCsrfToken(),
  },
});
